import { render, staticRenderFns } from "./SceneMaterialPointEntry.vue?vue&type=template&id=00231f78&scoped=true&"
import script from "./SceneMaterialPointEntry.vue?vue&type=script&lang=js&"
export * from "./SceneMaterialPointEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00231f78",
  null
  
)

export default component.exports